module.exports = function getResource(label, vars = []) {
    let resources = {
        toViewYourProfilePlease: 'Pour afficher votre profil, veuillez',
        signIn: 'ouvrir une session',
        notifications: 'Notifications',
        messages: 'Messages'
    };
    return resources[label];
};
